Revolution.Module.extend({
    NAME: "mde.bk-chiffres-cles", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/bk-chiffres-cles.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events
        if ($('.js-counter').length) {
            this.numCounter();
        }
    },

    onWindowLoad: function (e) {
    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },
    numCounter: function () {
        var controller = new ScrollMagic.Controller();
        var counters = $(".js-counter");
        var countDecimals = this.countDecimals;

        counters.each(function (index, elem) {
            var count = { val: 0 }
            var NewVal = parseFloat($(elem).data('max').toString());
            var suffix = $(elem).find('.js-counter-suffix').text();
            var isInt = NewVal % 1 === 0;
            var nbDecimals = !isNaN(NewVal) ? countDecimals(NewVal) : 0;

            var anim = gsap.to(count, 1, {
                val: NewVal,
                roundProps: isInt ? "val" : null,
                onUpdate: function () {
                    $(elem).addClass('active');
                    elem.innerHTML = parseFloat(count.val).toFixed(nbDecimals) + suffix;
                }
            });

            new ScrollMagic.Scene({
                triggerElement: ".bk-chiffres-cles",
                triggerHook: 1
            })
                .setTween(anim)
                .addTo(controller);
        })
    },

    countDecimals: function (value) {
        if(Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    },
});
